import { render, staticRenderFns } from "./PasswordRestoreModal.vue?vue&type=template&id=66a267b5"
import script from "./PasswordRestoreModal.vue?vue&type=script&lang=js"
export * from "./PasswordRestoreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports